import { useContext } from 'react'

import NotificationContext from '@/contexts/NotificationContext'

export default () => {
  const { addNotification } = useContext(NotificationContext)
  return addNotification
}
